module.exports = __webpack_public_path__ + "./img/notavailable.3d721a151a4237e1fe88bfd5dedbdd47.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Shared/images/notavailable.png
// module id = ./src/components/Shared/images/notavailable.png
// module chunks = 0